// react
import React from 'react'

// components
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import Header from '_components/header/index.jsx'
import NewEntityDialog from '_components/new-entity-dialog/index.jsx'
import ListView from '_components/list-view/index.jsx'

// libraries
import User from '../lib/User.js'

// Mapping IDs Page
class MappingIDsPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      companies: [],
      modalOpen: false,
    }
  }

  toggleModal = () => {
    this.setState((prevState) => ({
      modalOpen: !prevState.modalOpen,
    }))
  }

  componentDidMount() {
    User.watch(this, () => {
      this.loadCompanies()
    })
  }

  loadCompanies = () => {
    window._api.get('/companies', (error, resp) => {
      if (error) {
        toast.error(error.message)
      }
      this.setState({ companies: resp.items })
    })
  }

  render() {
    let { companies, modalOpen } = this.state

    return (
      <div id="mapping-ids-page">
        <Header
          title="Mapping IDs"
          actions={[
            {
              children: 'Create New Mapping ID',
              onClick: this.toggleModal,
            },
          ]}
        />

        <ListView
          columns={[
            {
              key: 'name',
              link: '/mapping-ids/:_id',
              sortable: true,
            },
            {
              key: 'company.name',
              link: `/companies/:company._id`,
              name: 'Company',
            },
            {
              key: 'description',
              name: 'Description',
            },
            {
              key: 'products',
              name: 'Products',
            },
          ]}
          entities="mapping-ids"
          fields={['name', 'company.name', 'description', 'products']}
          filters={[{ name: 'company', options: companies }]}
          searchable={true}
          sort_key={'name'}
          sort_dir={1}
        />
        <Dialog open={modalOpen} close={this.toggleModal}>
          <NewEntityDialog
            close={this.toggleModal}
            entities="mapping-ids"
            title="Enter a name for your new Mapping ID"
          />
        </Dialog>
      </div>
    )
  }
}

// export
export default MappingIDsPage
